import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import { FormattedMessage } from 'react-intl'
import { useResolutions } from 'store/resolutions'

import twoTickets from 'assets/icons/twoTickets.svg'
import Button from 'components/shared/Button'

import { BookAttractionWrapper } from './styles'
import { scrollTo } from 'helpers/animateScroll'

const BookAttractions = () => {
    const { isTablet } = useResolutions()

    return (
        <BookAttractionWrapper
            direction={['column', 'row']}
            align={['flex-start', 'center']}
            isFullWidth
            pt={24}
            pr={[16, 32]}
            pb={24}
            pl={[16, 32]}
            gap={[16, 24]}
        >
            {!isTablet && <img src={twoTickets} alt="Two tickets icon" />}
            {isTablet && (
                <>
                    <Box
                        direction="row"
                        justify="space-between"
                        align="center"
                        isFullWidth
                    >
                        <Text variant="heading5">
                            <Text
                                variant="heading5"
                                as="span"
                                color="primary_500"
                            >
                                <FormattedMessage
                                    id="selfcare.starter.book_attraction_tile_title_1"
                                    defaultMessage="Nie stój w kolejce"
                                />
                            </Text>
                            <br />
                            <Text
                                variant="heading5"
                                as="span"
                                color="secondary_500"
                            >
                                <FormattedMessage
                                    id="selfcare.starter.book_attraction_tile_title_2"
                                    defaultMessage="po atrakcje!"
                                />
                            </Text>
                        </Text>
                        <img src={twoTickets} alt="Two tickets icon" />
                    </Box>
                </>
            )}
            <Box>
                {!isTablet && (
                    <Text variant="heading5">
                        <Text variant="heading5" as="span" color="primary_500">
                            <FormattedMessage
                                id="selfcare.starter.book_attraction_tile_title_1"
                                defaultMessage="Nie stój w kolejce"
                            />
                        </Text>{' '}
                        <Text
                            variant="heading5"
                            as="span"
                            color="secondary_500"
                        >
                            <FormattedMessage
                                id="selfcare.starter.book_attraction_tile_title_2"
                                defaultMessage="po atrakcje!"
                            />
                        </Text>
                    </Text>
                )}

                <Text variant="bodySmall" color="grayscale_900">
                    <FormattedMessage
                        id="selfcare.starter.book_attraction_tile_content"
                        defaultMessage="Ciesz się zabawą w Suntago i specjalnymi atrakcjami, które przygotowaliśmy. Część z nich jest limitowana – wybierz i zarezerwuj je już dziś!"
                    />
                </Text>
            </Box>

            <Button
                variant="borderSecondary"
                width="initial"
                hasNoWrap
                onClick={() =>
                    scrollTo({ id: 'upgrade-attraction-row', duration: 500 })
                }
                testId="selfcare-no-upsell-button-cta"
            >
                <FormattedMessage
                    id="selfcare.starter.book_attraction_tile_button"
                    defaultMessage="Zarezerwuj atrakcje"
                />
            </Button>
        </BookAttractionWrapper>
    )
}

export default BookAttractions
